import { render, staticRenderFns } from "./UploadImages.vue?vue&type=template&id=bb83f126&scoped=true&"
import script from "./UploadImages.vue?vue&type=script&lang=js&"
export * from "./UploadImages.vue?vue&type=script&lang=js&"
import style0 from "./UploadImages.vue?vue&type=style&index=0&id=bb83f126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb83f126",
  null
  
)

export default component.exports